var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.94 38.74",
    style: {
      enableBackground: "new 0 0 39.94 38.74"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#111111;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.02,33.42l-9.9-6.19l-9.9,6.19V11.76c-0.03-1.67,1.3-3.06,2.97-3.09h13.86c1.67,0.03,3,1.42,2.97,3.09 V33.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.52,30.71V11.76c0-0.88-0.66-1.59-1.47-1.59H11.19c-0.81,0-1.47,0.71-1.47,1.59v18.95l8.4-5.25L26.52,30.71  M28.02,33.42l-9.9-6.19l-9.9,6.19V11.76c0-1.71,1.33-3.09,2.97-3.09h13.86c1.64,0,2.97,1.39,2.97,3.09V33.42z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.19de59d4a2c6d4e539d4a3d49703cfd8.svg";
export { ForwardRef as ReactComponent };